import React, { useState,useEffect } from "react";
import { Link } from 'react-router-dom';
import amaxLogo from "../../images/amaxLogoWhite.png";
import API_URL from '../../api/API';

export const AthleteForgotPassword = () => {

  const [email,setEmail] = useState('');
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!email) {
      setError('Please enter the email.');
      return;
    }

    setError(null);
    setMsg(null);
    setLoading(true);

  try {
      const response = await fetch(API_URL.POST_ATHLETE_FORGOT_PASSWORD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({email}),
      });

      const json = await response.json();
      setLoading(false);

      if (response.ok) {
          setMsg(json.message);
          setEmail('');
      } 
      else 
      {
        // Display error returned by the server
        setError(json.error || 'An error occurred. Please try again.');
      }
    } catch (err) {
      setLoading(false);
      setError('Failed to connect to the server. Please try again.');
    }
  };
 
  return (
    <div className="p-[20px] bg-white h-dvh overflow-hidden">
      <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
        <Link to="/" className="size-[96px] lg:size-[166px]">
            <img src={amaxLogo} alt="logo" className="object-contain" />
        </Link>

        <div className="w-full flex flex-col gap-8">
          <div className="flex flex-col gap-[15px]">
            <p className="text-black text-3xl xs:text-4xl leading-tight font-light">
              Forgot Password <br />
              <span className="text-4xl xs:text-5xl leading-tight font-bold">
                ATHLETE.
              </span>
            </p>
                  {/* Display Loading Indicator */}
                  {loading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )}

                 {/* Display Success Message */}
                 {msg && (
                <p className="text-green-500 text-sm mt-2">
                  {msg}
                </p>
              )}

                {/* Display Error Message */}
             {error && (
                  <p className="text-red-500 text-sm mt-2">
                    {error}
                  </p>
                )}
            <form action="" className="flex flex-col gap-[15px]">
              <input
                type="email"
                className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                placeholder="Email*"
                value={email}
                onChange={(e) => setEmail(e.target.value)}

              />
            </form>
           
              <button onClick={handleSubmit} className="text-center w-full p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300">
                RETRIVE PASSWORD
              </button>
           
            <Link
              to="/athlete/login"
              className="w-fit text-sm xs:text-base font-light text-black hover:text-black/70 transition-all duration-300 inline-block ml-auto"
            >
              Login
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
};
